export default {
	"contactUs": {
		"title": "เปิดบัญชี FCA เพื่อเข้าถึงกฎระเบียบชั้นนําและความปลอดภัยของเงิน",
		"title1": "เทรดเดอร์ที่จริงจังทุกคนสมควรได้รับการปฏิบัติอย่างจริงจัง",
		"code": "รหัสยืนยัน",
	},
	"dividend": {
		"title": "เงินปันผลจาก CFD",
		"title1": "การอ้างอิงเงินปันผลจาก CFD:",
		"desc": "*โปรดทราบ: การรวบรวมเงินปันผล CFD จะแสดงในยอดคงเหลือใน MT4 ของคุณเป็นการฝากหรือถอน โดยมีหมายเหตุว่า “เงินปันผล”",
		"btn": "เริ่มเทรด"
	},
	"contact": {
		"title": "การลงทุนของคุณเริ่มต้นที่นี่",
		"pageTitle": "สอบถาม",
		"pageEnTitle": "Inquiry",
		"name": "ชื่อ",
		"sexList": [{
			"label": "นาย",
			"value": "sir"
		}, {
			"label": "นางสาว",
			"value": "lady"
		}],
		"email": "โทรศัพท์ / อีเมล",
		"btn": "ส่ง",
		"tips1": "กรุณาป้อนที่อยู่ของคุณ!",
		"tips2": "โปรดระบุข้อมูลที่ติดต่อของคุณ!",
		"tips3": "ข่าวความสำเร็จ!",
		"tips4": "กรุณาใส่รหัสการตรวจสอบที่ถูกต้อง!"
	},
	"column1": {
		"placeholder": "ค้นหาเว็บไซต์ทั้งหมด",
		"login": "เข้าสู่ระบบ",
		"langText": "ภูมิภาค EBC / ภาษา",
		"langList": [{
			"text": "简体",
			"value": "zh_CN"
		}, {
			"text": "繁体",
			"value": "zh_TW"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		}]
	},
	"linkList": [{
		"title": "บัญชีและเงื่อนไข",
		"list": [{
				"label": "บัญชีธุรกรรม",
				"link": "/TradingAccount"
			},{
				"label": "ซื้อขายสินค้า",
				"link": "/tradingproduct"
			},{
				"label": "เลเวอเรจมาร์จิ้น",
				"link": "/leverage-margin"
			},
			{
				"label": "ฝากและถอนเงิน",
				"link": "/funding"
			},
			{
				"label": "เงินปันผล",
				"link": "/dividend"
			}
		]
	},{
		"title": "เครื่องมือการซื้อขาย",
		"list": [{
				"label": "ดาวน์โหลด MT4",
				"link": "/MT4"
			},{
				"label": "ดาวน์โหลด MT5",
				"link": "/MT5"
			},{
				"label": "เครื่องมือการซื้อขาย MT4",
				"link": "/tools"
			}, {
				"label": "PAMM",
				"link": "/PAMM"
			}, {
				"label": "การวิเคราะห์ตลาด",
				"link": "/market-analysis"
			}
		]
	},{
		"title": "EBCสถาบัน",
		"list": [{
				"label": "ศูนย์การเรียนรู้",
				"link": "/LearningCenter"
			}, {
				"label": "ศูนย์ข้อมูล",
				"link": "/lab"
			}
		]
	}, {
		"title": "เหตุการณ์ล่าสุด",
		"list": [{
			"label": "การแข่งขันการซื้อขาย",
			"link": "/win"
		},
		// {
		// 	"label": "ท้าทายกับสภาพแวดล้อมการเทรดที่ดีที่สุด",
		// 	"link": "/no1"
		// },
		{
			"label": "Creative Program",
			"link": "/cfa"
		}]
	}, {
		"title": "โหมดความร่วมมือ",
		"list": [{
			"label": "อิทธิพลที่มีต่อพันธมิตร",
			"link": "/affiliate-programmes"
		},{
			"label": "บริการสถาบัน",
			"link": "/service"
		},{
			"label": "เทคโนโลยีพื้นฐาน",
			"link": "/technology"
		}]
	}, {
		"title": "เกี่ยวกับ EBC",
		"list": [{
			"label": "WHY EBC",
			"link": "/about-us"
		},  {
			"label": "ความมั่นคงทางการเงิน",
			"link": "/LegalDocumen"
		}, {
			"label": "Sustainability & Impact",
			"link": "/ESG"
		}, {
			"label": "FAQ",
			"link": "/FAQ"
		},{
			"label": "การตรวจสอบช่องทางอย่างเป็นทางการ",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "หน้าหลัก",
		"url": "/"
	}, {
		"text": "การซื้อขาย",
		"menu": [{
			"text": "เครื่องมือการซื้อขาย",
			"url": "/tradingproduct"
		}, {
			"text": "บัญชีซื้อขาย",
			"url": "/TradingAccount"
		}, {
			"text": "เงื่อนไขการซื้อขาย",
			"menu": [{
				"text": "การฝากเงินและถอนเงิน",
				"url": "/funding"
			}, {
				"text": "เลเวอเรจและมาร์จิ้น",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "แพลตฟอร์มการซื้อขาย",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}]
		}, {
			"text": "เงินปันผล",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB&เครื่องมือ",
		"menu": [{
			"text": "ศูนย์เรียนรู้",
			"url": "/LearningCenter"
		}, {
			"text": "ศูนย์ข้อมูล",
			"url": "/lab"
		}]
	}, {
		"text": "สถาบัน",
		"menu": [{
			"text": "บริการสภาพคล่อง",
			"url": "/technology"
		}, {
			"text": "บริการของสถาบัน",
			"url": "/service"
		}]
	}, {
		"text": "พาร์ทเนอร์",
		"url": "/partner"
	}, {
		"text": "เกี่ยวกับ EBC",
		"menu": [{
			"text": "ทำไมต้อง EBC",
			"url": "/about-us"
		}, {
			"text": "คำถามพบบ่อย",
			"url": "/FAQ"
		}]
	}, {
		"text": "เปิดบัญชีฟรี",
		"url": "https://client.myebc.co/signup?bid=5s71xp"
	}],
	"login": "เข้าสู่ระบบ",
	"zhuce": "เปิดบัญชีฟรี",
	"gendan": "ชุมชนสารคดี",
	"pdfLang": "en",
	"bannerLang":"th",
	"language":'ภาษาไทย',
	"className": "th-box",
	"text": "กลุ่มองค์กรเครือข่าย EBC Financial Group ได้แก่:<br>EBC Financial Group (SVG) LLC ได้รับอนุญาตจาก St.Vincent และ Grenadines Financial Services Authority (SVGFSA) และหมายเลขจดทะเบียนบริษัทคือ 353 LLC 2020<br>EBC Financial Group (UK) Limited ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority แห่งสหราชอาณาจักร  หมายเลขอ้างอิง: 927552 เว็บไซต์: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) ได้รับอนุญาตและควบคุมโดย Australian Securities and Investments Commission (หมายเลขควบคุม: 500991) EBC Financial Group (Australia) Pty Ltd เป็นหน่วยงานที่เกี่ยวข้องกันของ EBC Financial Group (SVG) LLC แต่ทั้งสองหน่วยงานมีการดำเนินการและบริหารจัดการแยกออกจากกันเป็นอิสร ผลิตภัณฑ์และบริการทางการเงินที่มีให้บริการบนเว็บไซต์นี้ไม่ได้จัดทำโดยและไม่เกี่ยวข้องกับความรับผิดขององค์กรธุรกิจในออสเตรเลีย<br>EBC Financial Group (Cayman) Limited ได้รับอนุญาตและควบคุมโดยหน่วยงานการเงินหมู่เกาะเคย์แมน (หมายเลข: 2038223) เว็บไซต์: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>ที่อยู่บริษัท: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB ที่อยู่อีเมล: cs@ebc.comเบอร์โทรติดต่อ: +44 20 3376 9662<br>ข้อสงวนสิทธิ์: EBC Financial Group ไม่มีการเข้าร่วมในกิจกรรมสกุลเงินดิจิทัลใดๆ หรือเสนอสัญญาคริปโต สำหรับส่วนต่าง (CFD) ทั้งสิ้นอย่างชัดเจน บริการทางการเงินของเรานั้นเกี่ยวข้องกับตราสารแบบดั้งเดิมเท่านั้น ผู้ใช้บริการควรทราบการอ้างอิงถึงบริการที่เกี่ยวข้องกับการเข้ารหัสบัญชี โดยประสงค์อ้างชื่อ EBC นั้นเป็นการกระทำที่ผิดและไม่ได้รับอนุญาต ผลการดำเนินงานในอดีตไม่ได้บ่งบอกถึงผลการดำเนินงานในอนาคต และเนื้อหาบนเว็บไซต์มีไว้เพื่อการอ้างอิงเท่านั้น และไม่ถือเป็นคำแนะนำใดๆในการลงทุน<br>ข้อจำกัดภูมิภาค:EBC ไม่ได้ให้บริการแก่ผู้ใช้บริการที่อยู่ในเขตอำนาจศาลบางแห่ง ได้แก่ อัฟกานิสถาน เบลารุส เมียนมาร์ แคนาดา สาธารณรัฐอัฟริกากลาง คองโก คิวบา สาธารณรัฐประชาธิปไตยคองโก เอริเทรีย เฮติ อิหร่าน อิรัก เลบานอน ลิเบีย มาเลเซีย มาลี เกาหลีเหนือ (สาธารณรัฐประชาธิปไตยประชาชนเกาหลี) รัสเซีย โซมาเลีย ซูดาน ซูดานใต้ ซีเรีย ยูเครน (รวมถึงภูมิภาคไครเมีย โดเนตสค์ และลูฮันสค์) และสหรัฐอเมริกา เวเนซุเอลา และเยเมน สำหรับข้อมูลเพิ่มเติม สามารถอ่านได้ที่คำถามที่พบบ่อยของเรา<br>การเปิดเผยการปฏิบัติตามข้อกำหนด: เว็บไซต์ของบริษัทนั้นสามารถเข้าถึงได้ทั่วโลกและไม่ได้กำหนดเป้าหมายไปที่หน่วยงานใดๆ สิทธิ์และภาระผูกพันของคุณถูกกำหนดโดยหน่วยงานกำกับดูแลและหน่วยงานในภูมิภาคที่คุณเลือก กฎหมายและข้อบังคับในท้องถิ่นอาจห้ามหรือจำกัดไม่ให้คุณเข้าไป ดาวน์โหลด เผยแพร่ แบ่งปันหรือใช้เอกสารและข้อมูลใด ๆ ที่โพสต์บนเว็บไซต์<br>การซื้อขายผลิตภัณฑ์ที่มีความเสี่ยงสูง: CFD เป็นผลิตภัณฑ์ทางการเงินที่มีความซับซ้อน และการใช้เลเวอเรจที่มีความเสี่ยงสูงทำให้มีโอกาสที่จะขาดทุนได้อย่างรวดเร็ว ซึ่งการซื้อขายโดยใช้มาร์จิ้นนั้นมีความเสี่ยงสูงและอาจจะไม่เหมาะสำหรับนักลงทุนทุกคน คุณควรศึกษาข้อมูลข้างต้นให้เข้าใจก่อนการลงทุน โดยเทียบกับวัตถุประสงค์ สถานการณ์ทางการเงินของคุณ และความเสี่ยงที่จะได้รับ การลงทุนนี้อาจจะทำให้คุณสูญเสียเงินทุนบางส่วนหรือทั้งหมด เราขอแนะนำให้คุณขอคำแนะนำเพิ่มเติมเพื่อให้แน่ใจว่าคุณเข้าใจในความเสี่ยงทั้งหมดอย่างละเอียดก่อนตัดสินใจลงทุน โปรดอ่านคำชี้แจงให้ครบถ้วนเกี่ยวกับความเสี่ยงที่เกี่ยวข้องก่อนเริ่มทำการซื้อขายทุกครั้ง",
	"waptext": "กลุ่มองค์กรเครือข่าย EBC Financial Group ได้แก่:<br>EBC Financial Group (SVG) LLC ได้รับอนุญาตจาก St.Vincent และ Grenadines Financial Services Authority (SVGFSA) และหมายเลขจดทะเบียนบริษัทคือ 353 LLC 2020<br>EBC Financial Group (UK) Limited ได้รับอนุญาตและควบคุมโดย Financial Conduct Authority แห่งสหราชอาณาจักร  หมายเลขอ้างอิง: 927552 เว็บไซต์: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) ได้รับอนุญาตและควบคุมโดย Australian Securities and Investments Commission (หมายเลขควบคุม: 500991) EBC Financial Group (Australia) Pty Ltd เป็นหน่วยงานที่เกี่ยวข้องกันของ EBC Financial Group (SVG) LLC แต่ทั้งสองหน่วยงานมีการดำเนินการและบริหารจัดการแยกออกจากกันเป็นอิสร ผลิตภัณฑ์และบริการทางการเงินที่มีให้บริการบนเว็บไซต์นี้ไม่ได้จัดทำโดยและไม่เกี่ยวข้องกับความรับผิดขององค์กรธุรกิจในออสเตรเลีย<br>EBC Financial Group (Cayman) Limited ได้รับอนุญาตและควบคุมโดยหน่วยงานการเงินหมู่เกาะเคย์แมน (หมายเลข: 2038223) เว็บไซต์: <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>ที่อยู่บริษัท: The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB ที่อยู่อีเมล: cs@ebc.comเบอร์โทรติดต่อ: +44 20 3376 9662<br>ข้อสงวนสิทธิ์: EBC Financial Group ไม่มีการเข้าร่วมในกิจกรรมสกุลเงินดิจิทัลใดๆ หรือเสนอสัญญาคริปโต สำหรับส่วนต่าง (CFD) ทั้งสิ้นอย่างชัดเจน บริการทางการเงินของเรานั้นเกี่ยวข้องกับตราสารแบบดั้งเดิมเท่านั้น ผู้ใช้บริการควรทราบการอ้างอิงถึงบริการที่เกี่ยวข้องกับการเข้ารหัสบัญชี โดยประสงค์อ้างชื่อ EBC นั้นเป็นการกระทำที่ผิดและไม่ได้รับอนุญาต ผลการดำเนินงานในอดีตไม่ได้บ่งบอกถึงผลการดำเนินงานในอนาคต และเนื้อหาบนเว็บไซต์มีไว้เพื่อการอ้างอิงเท่านั้น และไม่ถือเป็นคำแนะนำใดๆในการลงทุน<br>ข้อจำกัดภูมิภาค:EBC ไม่ได้ให้บริการแก่ผู้ใช้บริการที่อยู่ในเขตอำนาจศาลบางแห่ง ได้แก่ อัฟกานิสถาน เบลารุส เมียนมาร์ แคนาดา สาธารณรัฐอัฟริกากลาง คองโก คิวบา สาธารณรัฐประชาธิปไตยคองโก เอริเทรีย เฮติ อิหร่าน อิรัก เลบานอน ลิเบีย มาเลเซีย มาลี เกาหลีเหนือ (สาธารณรัฐประชาธิปไตยประชาชนเกาหลี) รัสเซีย โซมาเลีย ซูดาน ซูดานใต้ ซีเรีย ยูเครน (รวมถึงภูมิภาคไครเมีย โดเนตสค์ และลูฮันสค์) และสหรัฐอเมริกา เวเนซุเอลา และเยเมน สำหรับข้อมูลเพิ่มเติม สามารถอ่านได้ที่คำถามที่พบบ่อยของเรา<br>การเปิดเผยการปฏิบัติตามข้อกำหนด: เว็บไซต์ของบริษัทนั้นสามารถเข้าถึงได้ทั่วโลกและไม่ได้กำหนดเป้าหมายไปที่หน่วยงานใดๆ สิทธิ์และภาระผูกพันของคุณถูกกำหนดโดยหน่วยงานกำกับดูแลและหน่วยงานในภูมิภาคที่คุณเลือก กฎหมายและข้อบังคับในท้องถิ่นอาจห้ามหรือจำกัดไม่ให้คุณเข้าไป ดาวน์โหลด เผยแพร่ แบ่งปันหรือใช้เอกสารและข้อมูลใด ๆ ที่โพสต์บนเว็บไซต์<br>การซื้อขายผลิตภัณฑ์ที่มีความเสี่ยงสูง: CFD เป็นผลิตภัณฑ์ทางการเงินที่มีความซับซ้อน และการใช้เลเวอเรจที่มีความเสี่ยงสูงทำให้มีโอกาสที่จะขาดทุนได้อย่างรวดเร็ว ซึ่งการซื้อขายโดยใช้มาร์จิ้นนั้นมีความเสี่ยงสูงและอาจจะไม่เหมาะสำหรับนักลงทุนทุกคน คุณควรศึกษาข้อมูลข้างต้นให้เข้าใจก่อนการลงทุน โดยเทียบกับวัตถุประสงค์ สถานการณ์ทางการเงินของคุณ และความเสี่ยงที่จะได้รับ การลงทุนนี้อาจจะทำให้คุณสูญเสียเงินทุนบางส่วนหรือทั้งหมด เราขอแนะนำให้คุณขอคำแนะนำเพิ่มเติมเพื่อให้แน่ใจว่าคุณเข้าใจในความเสี่ยงทั้งหมดอย่างละเอียดก่อนตัดสินใจลงทุน โปรดอ่านคำชี้แจงให้ครบถ้วนเกี่ยวกับความเสี่ยงที่เกี่ยวข้องก่อนเริ่มทำการซื้อขายทุกครั้ง"
}

